export const adminPartArticle = {
    id: 'admin-part',
    title: 'Административный режим',
    category: 'Основы',
    requiredModule: null,
    summary: 'Рабочее место сотрудника: анатомия экрана, переключение режимов и паспорт объекта.',
    markdown: `
# Административный режим (Рабочий кабинет)

> **Административный режим** — это защищённое рабочее место сотрудника. Здесь наносят на карту границы участков, чертят дороги и здания, меняют статусы и заполняют закрытые служебные данные, которые не видны обычным клиентам.

---

## 1. Как устроен рабочий экран

Интерфейс спроектирован так, чтобы не загромождать карту лишними кнопками: всё необходимое появляется только тогда, когда вы с этим работаете.

:::wireframe-admin

:::grid cols=2
:::card icon="layout" title="❶ Верхняя панель (Шапка)"
Здесь вы переключаете режимы работы (например, из «Данных» в «Рисование»), выбираете нужные инструменты, меняете тему (светлая/тёмная) и выходите из профиля.
:::

:::card icon="map" title="❷ Центральная интерактивная карта"
Главное рабочее поле. Здесь отображаются ваши участки, дороги и строения, а выбранный объект подсвечивается контрастным янтарным цветом.
:::

:::card icon="edit-3" title="❸ Быстрые действия (слева от паспорта)"
Вертикальная плашка кнопок прямо у левого края карточки: перерисовать геометрию контура ✏️, удалить объект 🗑️, а также кнопки быстрого доступа из подключаемых модулей.
:::

:::card icon="sidebar" title="❹ Панель «Настройка объекта» (Паспорт)"
Плавающая шторка справа с вкладками (*«Основное»*, *«Владение»*, *«Статусы»*, *«Медиа»*, *«Доп...»*) для заполнения характеристик участка или строения.
:::
:::

---

## 2. Два основных режима работы

Чтобы инструменты не путались под рукой, панель разделена на два привычных состояния:

| Что делаем | Режим «Рисование» ✏️ | Режим «Данные» 📊 |
| :--- | :--- | :--- |
| **Главная цель** | Оцифровка и черчение новых объектов на местности. | Аналитика, расчёты, замеры и наведение порядка в списках. |
| **Инструменты** | • Участки (земля)<br>• Здания (с высотой в 3D)<br>• Линии (дороги, заборы, трубы)<br>• Точки (КПП, парковки, пляжи) | • Электронная линейка (длина пути)<br>• Замер площади в сотках и м²<br>• «Пипетка» точных географических координат |
| **Работа с файлами** | Загрузка картинки генплана поверх карты (с настройкой прозрачности), импорт и экспорт контуров. | Управление цветами в легенде, сквозная таблица со списком всех участков посёлка. |

---

## 3. Паспорт объекта (Окно редактирования)

Как только вы закончили чертить новый участок или просто кликнули по уже существующему объекту, с правой стороны экрана плавно выезжает **Паспорт объекта**.

:::info Вся подноготная участка — в одном окне
В этом окне администратор заполняет:
1. **Публичные данные:** название, номер участка, площадь, статус готовности, фотографии и описание для клиентов.
2. **Служебную информацию (скрыта от гостей):** контакты собственника, стоимость за сотку, внутренние заметки менеджера и прикреплённые документы.
:::
`
};
